import { CREATE_LOAN } from './types';

export const createLoanRequest = (data: any) => {
  return {
    type: CREATE_LOAN.CREATE_LOAN_REQUEST,
    payload: {
      data,
    },
  } as const;
};

export const createLoanSuccess = (data: any) => {
  return {
    type: CREATE_LOAN.CREATE_LOAN_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const createLoanFailed = () => {
  return {
    type: CREATE_LOAN.CREATE_LOAN_FAILED,
  } as const;
};

export type ProvidentFundActions =
  | ReturnType<typeof createLoanRequest>
  | ReturnType<typeof createLoanSuccess>
  | ReturnType<typeof createLoanFailed>;
